//here are the list of actions.
export const SAVE_USER = "SAVE_USER";
export const SAVE_SEARCHED_PROJECTS_RESULTS = "SAVE_SEARCHED_PROJECTS_RESULTS";
export const DELETE_PROJECT_ROOM = "DELETE_PROJECT_ROOM";
export const SAVE_PROJECT_ROOMS = "SAVE_PROJECT_ROOMS";

export const UPDATE_PROJECT_ROOM = "UPDATE_PROJECT_ROOM";
export const CLEAR_UPDATED_ROOMS_GLOBAL_STATE = "CLEAR_UPDATED_ROOMS_GLOBAL_STATE";
export const ADD_NEW_PROJECT_ROOM_TO_ADD_TO_THE_DATABASE =
	"ADD_NEW_PROJECT_ROOM_TO_ADD_TO_THE_DATABASE";
export const LOG_OUT = "LOG_OUT";
export const DELETE_CONSULTANT_WAWREHOUSE = "DELETE_CONSULTANT_WAREHOUSE";

export const UPDATE_LIST_OF_PRODUCT_CARDS_TO_DISPLAY = "UPDATE_LIST_OF_PRODUCT_CARDS_TO_DISPLAY";
export const CLEAR_ROOM_NAMES = "CLEAR_ROOM_NAMES";
export const SAVE_ACCOUNT_ID_FOR_GETTING_PRODUCT_INFORMATION_LATER =
	"SAVE_ACCOUNT_ID_FOR_GETTING_PRODUCT_INFORMATION_LATER";
export const SAVE_PROJECT_ID_TO_INCREASE_THE_QUANTITY_OF_A_PRODUCT =
	"SAVE_PROJECT_ID_TO_INCREASE_THE_QUANTITY_OF_A_PRODUCT";
export const STOP_DISPLAYING_QUOTE_NAV_BUTOTN = "STOP_DISPLAYING_QUOTE_NAV_BUTOTN";
export const SAVE_WAREHOUSE_NUMBER_FOR_QUOTE_SCREEN = "SAVE_WAREHOUSE_NUMBER_FOR_QUOTE_SCREEN";
export const SAVING_ACTING_AS_AN_AGENT = "SAVING_ACTING_AS_AN_AGENT";
export const DISPLAY_CHECK_PRICES_BUTTON_ON_NAV_BAR = "DISPLAY_CHECK_PRICES_BUTTON_ON_NAV_BAR";
export const DISPLAY_CHECK_PRODUCT_DETAILS_ON_NAV_BAR = "DISPLAY_CHECK_PRODUCT_DETAILS_ON_NAV_BAR";
export const STORE_THIS_PROJECT_SHIP_TO_FOR_DISPLAYING_NON_STOCK_IN_PRODUCT_SHOPPING =
	"STORE_THIS_PROJECT_SHIP_TO_FOR_DISPLAYING_NON_STOCK_IN_PRODUCT_SHOPPING";
export const DISPLAY_PRODUCT_SHOPPING_BUTTON_ON_NAV_BAR =
	"DISPLAY_PRODUCT_SHOPPING_BUTTON_ON_NAV_BAR";
export const DISPLAY_QUOTE_LINK_ON_NAV_BAR = "DISPLAY_QUOTE_LINK_ON_NAV_BAR";
export const TOGGLE_LANGUAGE = "TOGGLE_LANGUAGE";
export const UPDATE_SELECTED_GROUPS = "UPDATE_SELECTED_GROUPS";
export const ALERT_DETAILS_UPDATE = "ALERT_DETAILS_UPDATE";
